import Operation from '@utils/common/operation'
import Form from '@utils/form'
import Dialog from '@utils/common/dialog'
import SeeCell from '../components/see-cell.vue'
import http from '@plugin/axios'
const dialog = new Dialog('performance.performancequery')
  .title('see')
  .isfooter(false)
  .component(SeeCell)

const form = new Form('performance.performancequery')
  .add('adjustmentScore').merge('number').bind('max', 100).bind('min', 0).col(24)

// 调整分数
async function adjustscore(vm: any) {
  const { row, data } = vm
  await http({
    url: '/srmPerformanceScore/srmPerformanceScoreAdjustScore',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { adjustmentScore: data.adjustmentScore, id: row.id }
  })
  row.adjustmentScore = data.adjustmentScore
}
// 发布
async function release(this: any, row: any) {
  await this.$confirm(this.$t('performance.performancequery.releaseMessage'))
  await http({
    url: '/srmPerformanceScore/srmPerformanceScoreRelease',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      id: row.id,
      qualitativeScore: row.qualitativeScore,
      rationScore: row.rationScore,
      supOfficeNo: row.supOfficeNo,
      performanceDate: row.performanceDate,
      purOfficeNo: row.purOfficeNo
    }
  })
  this.refresh()
}
// 作废
async function cancel(this: any, row: any) {
  await this.$confirm(this.$t('performance.performancequery.cancelMessage'))
  await http({
    url: '/srmPerformanceScore/srmPerformanceScoreInvalid',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id: row.id }
  })
  this.refresh()
}
// 撤回
async function recall(this: any, row: any) {
  await this.$confirm(this.$t('performance.performancequery.recallMessage'))
  await http({
    url: '/srmPerformanceScore/srmPerformanceScoreRecall',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id: row.id }
  })
  this.refresh()
}
// 查看评分
function see(row: any) {
  dialog.open({ attrs: { data: row }})
}

const operation = new Operation('performance.performancequery')
  .width(220)
  .add('adjustscore').show(row => row.status === '1').form(form, adjustscore, { title: 'performance.performancequery.adjustscore', width: '300px' })
  .add('release').show(row => row.status === '1').handle(release)
  .add('cancel').show(row => row.status !== '3').handle(cancel)
  .add('recall').show(row => row.status === '3').handle(recall)
  .add('see').handle(see)

export default operation
